module.exports = __webpack_public_path__ + "static/media/ed-tick-red.405f99c1.svg";